<div id="left-sidebar" class="sidebar">

  <div class="sidebar-scroll">


    <!-- ===================================================== -->
    <!-- USER ACCOUNT -->
    <!-- ===================================================== -->

    <div class="user-account">

      <img
        src="../assets/images/user.png"
        class="rounded-circle user-photo"
        alt="Profile Picture"
      >


      <div class="dropdown">

        <span>Hello,</span>


        <a
          href="javascript:void(0)"
          class="dropdown-toggle user-name"
          data-toggle="dropdown">

          <strong>
            {{ currentUser?.full_name || "User" }}
          </strong>

        </a>


        <ul
          class="dropdown-menu dropdown-menu-right account">

          <li>

            <a
              [routerLink]="['/admin/settings/payment-channel']">

              <i class="icon-settings"></i>

              Settings

            </a>

          </li>


          <li class="divider"></li>


          <li>

            <a
              href="javascript:void(0)"
              (click)="logOut()">

              <i class="icon-power"></i>

              Logout

            </a>

          </li>

        </ul>

      </div>


      <hr>

    </div>



    <!-- ===================================================== -->
    <!-- MAIN MENU -->
    <!-- ===================================================== -->

    <div class="tab-content p-l-0 p-r-0">

      <nav
        id="left-sidebar-nav"
        class="sidebar-nav">

        <ul
          id="main-menu"
          class="metismenu">


          <!-- ================================================= -->
          <!-- DASHBOARD -->
          <!-- ================================================= -->

          <li
            id="dashboard"
            class="navLinks nav-link-special"
            [class.active]="isActiveRoute('/admin/dashboard')">

            <a
              [routerLink]="['/admin/dashboard']">

              <i class="fa fa-home"></i>

              <span>
                Dashboard
              </span>

            </a>

          </li>



          <!-- ================================================= -->
          <!-- SUPER AGENTS -->
          <!-- ================================================= -->

          <li
            id="super-agent"
            class="navLinks nav-link-special"
            [class.active]="isActiveRoute('/admin/super-agents')">

            <a
              [routerLink]="['/admin/super-agents']">

              <i class="fa fa-user-check"></i>

              <span>
                Super Agents
              </span>

            </a>

          </li>



          <!-- ================================================= -->
          <!-- AGENTS -->
          <!-- ================================================= -->

          <li
            id="agents"
            class="navLinks nav-link-special"
            [class.active]="isActiveRoute('/admin/agents')">

            <a
              [routerLink]="['/admin/agents']">

              <i class="fa fa-user-alt"></i>

              <span>
                Agents
              </span>

            </a>

          </li>



          <!-- ================================================= -->
          <!-- SETTLEMENT -->
          <!-- ================================================= -->

          <li
            id="settlement"
            class="navLinks nav-link-special"
            [class.active]="isSettlementActive()">


            <!-- PARENT -->

            <a
              href="javascript:void(0)"
              class="has-arrow"
              [attr.aria-expanded]="settlementOpen"
              (click)="toggleSettlement()">

              <i class="fa fa-user-alt"></i>

              <span>
                Settlement
              </span>

            </a>


            <!-- CHILDREN -->

            <ul
              class="collapse childNavDropDown"
              [class.in]="settlementOpen"
              [class.show]="settlementOpen"
              [attr.aria-expanded]="settlementOpen">


              <!-- SETTLEMENT PREVIEW -->

              <li
                [class.active]="isActiveRoute('/admin/settlement')">

                <a
                  [routerLink]="['/admin/settlement']">

                  Settlement Preview

                </a>

              </li>


              <!-- SETTLEMENT HISTORY -->

              <li
                [class.active]="isActiveRoute('/admin/settlement-history')">

                <a
                  [routerLink]="['/admin/settlement-history']">

                  Settlement History

                </a>

              </li>


            </ul>

          </li>



          <!-- ================================================= -->
          <!-- MANAGE RIDERS -->
          <!-- ================================================= -->

          <!-- <li
            id="riders"
            class="navLinks nav-link-special"
            [class.active]="isRidersActive()">


            <a
              href="javascript:void(0)"
              class="has-arrow"
              [attr.aria-expanded]="ridersOpen"
              (click)="toggleRiders()">

              <i class="fa fa-biking"></i>

              <span>
                Manage Riders
              </span>

            </a>


            <ul
              class="collapse childNavDropDown"
              [class.in]="ridersOpen"
              [class.show]="ridersOpen"
              [attr.aria-expanded]="ridersOpen">


              <li
                [class.active]="isActiveRoute('/admin/riders')">

                <a
                  [routerLink]="['/admin/riders']">

                  Riders

                </a>

              </li>


            </ul>

          </li> -->



          <!-- ================================================= -->
          <!-- COMMISSION SETUP -->
          <!-- ================================================= -->

          <li
            id="commission"
            class="navLinks nav-link-special"
            [class.active]="isCommissionActive()">


            <!-- PARENT -->

            <a
              href="javascript:void(0)"
              class="has-arrow"
              [attr.aria-expanded]="commissionOpen"
              (click)="toggleCommission()">

              <i class="fa fa-share-alt"></i>

              <span>
                Commission Setup
              </span>

            </a>


            <!-- CHILDREN -->

            <ul
              class="collapse childNavDropDown"
              [class.in]="commissionOpen"
              [class.show]="commissionOpen"
              [attr.aria-expanded]="commissionOpen">


              <!-- MANAGE COMMISSION -->

              <li
                [class.active]="isActiveRoute('/admin/commission-sharing')">

                <a
                  [routerLink]="['/admin/commission-sharing']">

                  Manage Commission

                </a>

              </li>


              <!-- MANAGE BENEFICIARIES -->

              <li
                [class.active]="isActiveRoute('/admin/beneficiaries')">

                <a
                  [routerLink]="['/admin/beneficiaries']">

                  Manage Beneficiaries

                </a>

              </li>


              <!-- MANAGE TRANSACTION TYPE -->

              <li
                [class.active]="isActiveRoute('/admin/transaction-types')">

                <a
                  [routerLink]="['/admin/transaction-types']">

                  Manage Transaction Type

                </a>

              </li>


            </ul>

          </li>



          <!-- ================================================= -->
          <!-- REPORTS -->
          <!-- ================================================= -->

          <li
            id="transaction"
            class="navLinks nav-link-special"
            [class.active]="isReportsActive()">


            <!-- PARENT -->

            <a
              href="javascript:void(0)"
              class="has-arrow"
              [attr.aria-expanded]="reportsOpen"
              (click)="toggleReports()">

              <i class="icon-list"></i>

              <span>
                Reports
              </span>

            </a>


            <!-- CHILDREN -->

            <ul
              class="collapse childNavDropDown"
              [class.in]="reportsOpen"
              [class.show]="reportsOpen"
              [attr.aria-expanded]="reportsOpen">


              <!-- TRANSACTION REPORT -->

              <li
                [class.active]="isActiveRoute('/admin/report/transaction')">

                <a
                  [routerLink]="['/admin/report/transaction']">

                  Revenue Report

                </a>

              </li>
              <!-- REMITTANCE REPORT -->

              <li
                [class.active]="isActiveRoute('/admin/report/remittance')">

                <a
                  [routerLink]="['/admin/report/remittance']">

                  Remittance Report

                </a>

              </li>


            </ul>

          </li>



          <!-- ================================================= -->
          <!-- SETTINGS -->
          <!-- ================================================= -->

          <li
            id="settings"
            class="navLinks nav-link-special"
            [class.active]="isSettingsActive()">


            <!-- PARENT -->

            <a
              href="javascript:void(0)"
              class="has-arrow"
              [attr.aria-expanded]="settingsOpen"
              (click)="toggleSettings()">

              <i class="fa fa-cogs"></i>

              <span>
                Settings
              </span>

            </a>


            <!-- CHILDREN -->

            <ul
              class="collapse childNavDropDown"
              [class.in]="settingsOpen"
              [class.show]="settingsOpen"
              [attr.aria-expanded]="settingsOpen">


              <!-- PAYMENT CHANNELS -->

              <li
                [class.active]="isActiveRoute('/admin/settings/payment-channel')">

                <a
                  [routerLink]="['/admin/settings/payment-channel']">

                  Payment Channels

                </a>

              </li>



              <!-- MANAGE ZONES -->

              <li
                [class.active]="isActiveRoute('/admin/settings/manage-zones')">

                <a
                  [routerLink]="['/admin/settings/manage-zones']">

                  Manage Zones

                </a>

              </li>

              <li
                [class.active]="isActiveRoute('/admin/settings/manage-categories')">

                <a
                  [routerLink]="['/admin/settings/manage-categories']">

                  Manage Categories

                </a>

              </li>



              <!-- CONFIGURATIONS -->

              <li
                [class.active]="isActiveRoute('/admin/settings/configurations')">

                <a
                  [routerLink]="['/admin/settings/configurations']">

                  Configurations

                </a>

              </li>



              <!-- CHANGE PASSWORD -->

              <li
                [class.active]="isActiveRoute('/admin/settings/change-password')">

                <a
                  [routerLink]="['/admin/settings/change-password']">

                  Change Password

                </a>

              </li>


            </ul>

          </li>


        </ul>

      </nav>

    </div>

  </div>

</div>